module.exports = __webpack_public_path__ + "img/13d.8848b071.svg";